import React, { useState, useEffect } from 'react';
import FractalCreationForm from './FractalCreationForm';
import FractalDetails from './FractalDetails';
import { obtenerFractales } from '../api/fractalService';

const FractalList = ({ onSelectFractal }) => {
  const [fractales, setFractales] = useState([]);
  const [selectedFractal, setSelectedFractal] = useState(null);

  useEffect(() => {
    //obtenerFractales().then((data) => setFractales(data));
  }, []);

  const handleSelectFractal = (fractal) => {
    setSelectedFractal(fractal);
    onSelectFractal(fractal);  // Notificar al componente principal
  };

  return (
    <div>
      <h2>Fractales</h2>
      <ul>
        {fractales.map((fractal) => (
          <li key={fractal.id} onClick={() => handleSelectFractal(fractal)}>
            {fractal.nombre}
          </li>
        ))}
      </ul>
      <FractalCreationForm onFractalCreated={setFractales} />
      {selectedFractal && <FractalDetails fractal={selectedFractal} />}
    </div>
  );
};

export default FractalList;
